import { Link } from "react-router-dom";
import { Class } from "../../const";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../providers/UserProvider";
import EeljCountdown from "../eelj/EeljCountdown";
import NewsSlider from "../news/news-slider";
import ServiceSlider from "../service/service-slider";


const stats = [
  { id: 1, name: "Үндсэн ээлж", value: "14 900 +" },
  { id: 2, name: "Өдрийн амрагч", value: "16 000 +" },
  { id: 3, name: "Нийт амрагч", value: "30 900 +" },
];

const Home = () => {
  const {eeljuud, userBio, fetchEeljuud} = useContext(UserContext);

  const [curDate, setCurDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurDate(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    fetchEeljuud();
  }, [fetchEeljuud]);




  return (
    <>
      <div className="bg-white">
        <div className="relative isolate pt-14">
          <div
            className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
            aria-hidden="true"
          >
            <div
              className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
          <div className="py-24 sm:py-32 lg:pb-40">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-6xl text-center">
   
                  <>
                    <h1 className="text-lg text-gray-900 md:text-3xl italic font-bold">
                      Олон улсын хүүхдийн Найрамдал цогцолборт тавтай морил!
                    </h1>
                  

                    { eeljuud.activeEelj.length === 0 ?
                      <p className="mt-6 text-lg text-gray-600 text-center sm:px-36 text-[14px] leading-normal">
                        ЧАНАРТАЙ ҮЙЛЧИЛГЭЭ, НАЙРСАГ ХАРИЛЦААГ ЭРХЭМЛЭН ХҮҮХДИЙН АЯ
                        ТУХТАЙ ОРЧИН БҮРДҮҮЛЖ ХӨГЖИХ, ОРОЛЦОХ ЭРХИЙГ ТАНЬ ХАНГАХАД
                        ЧИГЛЭГДСЭН ХӨГЖЛИЙН ХӨТӨЛБӨРҮҮДЭЭР ҮЙЛЧИЛЖ БАЙНА.
                      </p>
                      :                    
                      <EeljCountdown {...eeljuud.activeEelj[0]}/>
                    }

                  
                  </>


                  <div className="mt-10 flex gap-1 items-center justify-center text-[#08B3EC]">
                  <Link to={'/eelj'}>
                    <a className="rounded-full bg-[#07B2EC] px-3.5 py-2.5 text-sm font-semibold text-[white] shadow-sm mr-2" >Ээлжийн мэдээлэл</a>
                  </Link>

                  {!userBio ?
                    <Link to={'/register'}>
                      <a className="rounded-full bg-[#FF0A36] px-3.5 py-2.5 text-sm font-semibold text-[white] shadow-sm" >Бүртгүүлэх</a>
                    </Link>
                    :
                    eeljuud.activeEelj.length > 0 && new Date(eeljuud.activeEelj[0].orderStartDate) < curDate ?
                    <Link to={`/payment/${eeljuud.activeEelj[0].id}`}>
                      <a className="rounded-full bg-[#07B2EC] px-3.5 py-2.5 text-sm font-semibold text-[white] shadow-sm mr-2" >Захиалах</a>
                    </Link> 
                    : null
                  }
                  
                  </div>
                
              </div>
              <div className="mt-16 sm:mt-24">
                <div className="-m-2 lg:-m-4 lg:rounded-2xl lg:p-4">
                  <img
                    src="/hero1.jpeg"
                    alt="App screenshot"
                    width={2432}
                    height={1442}
                    className="rounded-md  ring-gray-900/10"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
            aria-hidden="true"
          >
            <div
              className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
        </div>
      </div>
      {/* Stats */}
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:max-w-none">
            <div className="text-center">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl italic">
                Манайд амрагчдын тоо
              </h2>
              <p className="mt-4 text-lg leading-8 text-gray-600">
                БИД ТА БҮХЭНД ҮНДСЭН БОЛОН ӨДРИЙН АМРАГЧ ГЭСЭН БҮТЭЭГДЭХҮҮН,
                ҮЙЛЧИЛГЭЭ ҮЗҮҮЛЖ БАЙНА.
              </p>
            </div>
            <dl className="mt-16 grid grid-cols-1 gap-0.5 overflow-hidden rounded-2xl text-center sm:grid-cols-2 lg:grid-cols-3">
              {stats.map((stat) => (
                <div key={stat.id} className="flex flex-col bg-gray-400/5 p-8">
                  <dt className="text-sm font-semibold leading-6 text-gray-600">
                    {stat.name}
                  </dt>
                  <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900 italic">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
      {/* undsen eelj */}

      <div className="bg-white">
        <div className="relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20">
          <div className="mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40">
            <div className="px-6 lg:px-0 lg:pt-4">
              <div className="mx-auto max-w-2xl">
                <div className="max-w-lg">
                  <h1 className="mt-10 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl italic">
                  Үндсэн ээлжийн мэдээлэл
                  </h1>
                  <p className="mt-6 text-lg leading-8 text-gray-600">
                    Тус цогцолбор нь жилийн туршид 3, 5, 7, 10 хоногоор 40-45
                    үндсэн ээлж зохион байгуулдаг ба үндсэн ээлжээ хавар, намар,
                    зун, өвөл гэсэн хэлбэрээр зохион байгуулдаг.
                  </p>
                  <div className="mt-10 flex items-center gap-x-6">
                    <Link
                      to="/eelj"
                      className="rounded-full bg-[#07B2EC] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm"
                    >
                      Ээлжийн мэдээлэл
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen">
              <div
                className="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 md:-mr-20 lg:-mr-36"
                aria-hidden="true"
              />
              <img
                src="/undsen_eelj.jpeg"
                width={1200}
                height={600}
                alt=""
                className="p-4 rounded-md"
              />
            </div>
          </div>
          <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
        </div>
      </div>
      {/* udriin eelj */}


      <div className="bg-white">
        <div className="relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20">
          <div className="mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40">
            <div className="px-6 lg:px-0 lg:pt-4">
              <div className="mx-auto max-w-2xl">
                <div className="max-w-lg">
                  <h1 className="mt-10 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl italic">
                    Өдрийн амралт
                  </h1>
                  <p className="mt-6 text-lg leading-8 text-gray-600">
                    Эрхэм хүүхдүүд ээ! Байгалийн сайханд цэвэр агаарт гарч анги
                    хамт олноороо нэг өдрийг хөгжилтэй, дурсамжтай өнгөрөөхийг
                    хүсвэл бидэнд хандаарай. Та бүхнийг олон сонирхолтой
                    хөтөлбөрүүд хүлээж байна.
                  </p>
                  <div className="mt-10 flex items-center gap-x-6">
                    <Link
                      to="/busad-hutulbur/1"
                      className="rounded-full bg-[#07B2EC] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm"
                    >
                      Дэлгэрэнгүй
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen">
              <div
                className="absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 md:-mr-20 lg:-mr-36"
                aria-hidden="true"
              />
              <img
                src="/Busad-hutulbur-1.jpg"
                width={1200}
                height={600}
                alt=""
                className="p-4 rounded-md"
              />
            </div>
          </div>
          <div className="absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32" />
        </div>
      </div>

           
      <ServiceSlider/>

      {/* Blogs */}
      <NewsSlider />
    </>
    
  )
};

export default Home;